import styled from 'styled-components';

import { media, hexToRgba, getThemeColor } from '@utils/styled';

export const BenefitsWrapper = styled.ul`
  display: grid;
  grid-template-columns: 1fr;
  gap: 1.5rem 3rem;
  margin: 0;
  padding: 0;
  list-style: none;

  ${media.from640up`
    grid-template-columns: 1fr 1fr;
  `}
`;

export const Benefit = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

export const BenefitIconWrapper = styled.div`
  display: flex;
  flex-shrink: 0;
  justify-content: center;
  align-items: center;
  width: 3.2rem;
  height: 3.2rem;
  border-radius: 50%;
  background-color: ${({ theme }) =>
    hexToRgba(getThemeColor('bluegrey.60')({ theme }), 0.2)};
`;
